import angular from 'angular';
import angularUiRouter from '@uirouter/angularjs';
import ngInfiniteScroll from 'ng-infinite-scroll';
import ngFileUpload from 'ng-file-upload';
import angularElastic from 'angular-elastic';

export default angular.module('supportModule', [
    'helperModule',
    'cloudService',
    'supportApi',
    'asBreadcrumb',
    'asRangeLabel',
    'ngSanitize',
    'shared',
    angularElastic,
    angularUiRouter,
    ngFileUpload,
    ngInfiniteScroll
]);



// WEBPACK FOOTER //
// ./modules/support/support.module.js